<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-chart-line"></i></div>
      <div>
        Suivi des acquis
        <div class="page-title-subheading">Suivi des acquis des élèves</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>

<div  class="card mb-3">
  <div class="card-body py-3">
    <div class="row g-3 align-items-end">
      <div class="col-12 col-md-4">
        <label for="" class="form-label mb-0">Choisir la classe</label>
        <select class="form-select form-select-sm" (change)="loadStudents($event)" >
            <option selected disabled></option>
            <option *ngFor="let classroom of classrooms" [value]="classroom?.id">{{classroom?.name}}</option>
        </select>
      </div>
      <div class="col-12 col-md-4">
        <label for="" class="form-label mb-0">Choisir la période</label>
        <select class="form-select form-select-sm" [(ngModel)]="periodId" name="periodId" (change)="loadProjectAy($event)">
            <option selected disabled></option>
            <option *ngFor="let p of periods" [value]="p?.id">{{p?.name}}</option>
        </select>
      </div>
      <div class="col-12 col-md-4">
        <label for="" class="form-label mb-0">Choisir l'apprenant</label>
        <select class="form-select form-select-sm" (change)="setSacId($event)"  >
            <option selected disabled></option>
            <option *ngFor="let sac of students" [value]="sac?.id">{{sac?.student?.lastname}} {{sac?.student?.firstname}}</option>
        </select>
      </div>
    </div>
  </div>
</div>
<div class="text-center" *ngIf="periodId && periodId">
    <button class="btn btn-sm btn-primary" (click)="getTemplate()">Voir le format de bulletin</button>
</div>

<div class="container">
    <h5 class="text-center"><strong>Suivi des acquis scolaires de l’élève</strong></h5>
    <form class="mb-5" #addForm="ngForm" (ngSubmit)="storeLevelSkill(addForm.value)">

        <p>{{data!.length}} élément(s)</p>
        <div class="table-responsive">
        <table class="table table-sm table-bordered">
        <thead>
            <tr>
                <th colspan="2" rowspan="2">Domaines d'enseignements</th>
                <th rowspan="2">Principaux éléments du programme travaillés durant la période</th>
                <th rowspan="2">Acquisition, progrès et difficultés éventuelles</th>
                <th attr.colspan="{{sanctions.length}}">
                    <dl>
                        <dt>Positionnement</dt>
                        <dd>Objectifs d’apprentissage</dd>
                    </dl>
                </th>
            </tr>
            <tr>
                <th *ngFor="let s of sanctions" style=" writing-mode: vertical-lr;transform: rotate(180deg);">{{s}}</th>
            </tr>
        </thead>
        <tbody>
        
            <ng-container *ngIf="sacInfo!=undefined" >
                    <tr *ngFor="let c of sacInfo; let i=index">
                        <ng-container *ngIf="c.has_subs">
                            <td *ngIf="i==0"  attr.rowspan="{{index}}">
                                <div class="d-flex justify-content-between">
                                    <span>{{c.name}}</span>
                                </div>
                                
                                </td>
                                <td>
                                    <ul *ngFor="let sb of c.details; let j=index">
                                        <li>
                                            <span>{{sb.name}}</span>
                                            <hr>
                                        </li>
                                    </ul>
                                </td>
                                <td>
                                    <ng-container *ngFor="let sb of c.details; let j=index">
                                        <ul>
                                            <li *ngFor="let sk of sb.details; let k=index">
                                                    {{sk.name}}
                                                    <hr>                                   
                                            </li>
                                            
                                        </ul>
                                    </ng-container>
                                    
                                </td>
                        </ng-container>
                        <ng-container *ngIf="!c.has_subs">
                            <td  attr.rowspan="{{c.index}}" colspan="2">
                                <div class="d-flex justify-content-between">
                                    <span>{{c.name}}</span>
                                </div>
                                
                                </td>
                                <td>
                                    <ul>
                                        <li *ngFor="let sk of c.details; let k=index">
                                                {{sk.name}}
                                                <hr>                                   
                                        </li>
                                        
                                    </ul>
                                </td>
                        </ng-container>
                        
                
                    <td >
                        <textarea name="message" [(ngModel)]="sacInfo[i].message" class="form-control" readonly></textarea>
                    </td>
                    <td *ngFor="let s of sanctions; let r=index">
                        <ng-container *ngIf="c.has_subs">
                            <ng-container *ngFor="let sb of c.details; let j=index">
                            <ul>
                                <li *ngFor="let sk of sb.details; let k=index">
                                    <div class="form-check">
                                        <input class="form-check-input" [value]="r+1" [(ngModel)]="sacInfo[i]['details'][j]['details'][k].status" type="radio" name="status{{sk.id}}" id="flexRadioDefault{{sk.id}}">
                                    </div>    
                                    <hr>                       
                                </li>
                                
                            </ul>
                        </ng-container>
                    </ng-container>
                        <ng-container *ngIf="!c.has_subs">
                            <ul>
                                <li *ngFor="let sk of c?.details; let k=index">
                                    <div class="form-check">
                                        <input class="form-check-input" [value]="r+1" [(ngModel)]="sacInfo[i]['details'][k]['details'].status" type="radio" name="status{{sk.id}}" id="flexRadioDefault{{sk.id}}">
                                    </div>    
                                    <hr>                       
                                </li>
                                
                            </ul>
                        </ng-container>
                    
                    
                    </td>
                    </tr>
                    <!-- <tr *ngFor="let sb of c.pacc.subs; let i=index;">
                        <td *ngIf="i==0" attr.rowspan="{{c.pacc.subs.length}}"   style="writing-mode: vertical-lr;transform: rotate(180deg);">
                        <div class="d-flex justify-content-between">
                            <span>{{c.name}}</span>
                            <span (click)="add(addContent,c.pacc.id)"><i  class="fa fa-plus text-primary" style="cursor: pointer;"></i></span>
                        </div>
                        </td>
                        <td>{{sb.name}}</td>
                        <td>
                            <ul>
                                <li *ngFor="let sk of sb.skills; let k=index">
                                        {{sk.name}}
                                        <hr>                                   
                                </li>
                                
                            </ul>
                            <span (click)="add2(addContent2,sb.id)">Ajouter une compétence <i  class="fa fa-plus text-primary" style="cursor: pointer;"></i></span>
                        </td>
                        <td *ngIf="i==0" attr.rowspan="{{c.pacc.subs.length}}" >
                            <textarea name="message" ngModel class="form-control"  [readonly]="sacInfo==undefined"></textarea>
                        </td>
                        <td *ngFor="let s of sanctions; let r=index">
                            <ul>
                                <li *ngFor="let sk of sb.skills; let k=index">
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="flexRadioDefault{{i}}{{k}}" id="flexRadioDefault{{i}}{{k}}"  [readonly]="sacInfo==undefined">
                                    </div>    
                                    <hr>                       
                                </li>
                                
                            </ul>
                        
                        </td>
                    </tr> -->
                    
                
            </ng-container>
        </tbody>
        </table>
        </div>

  </form>

  <ng-container *ngIf="periodId!=undefined && pacId!=undefined">
  
    <table class="mb-5" class="table table-sm">
        <thead>
            <th>Projet(s) mis en œuvre </th>
        </thead>
        <tbody>
            <tr *ngFor="let p of projects">
                <td>{{p.title}}</td>
            </tr>
        </tbody>
    </table>
  </ng-container>
  <ng-container  *ngIf="periodId!=undefined && sacId!=undefined">
    <h5 class="text-center"><strong>Bilan de l’acquisition des connaissances et compétences</strong></h5>
    <form class="mb-5" #addForm="ngForm" (ngSubmit)="storeAssessment(addForm.value)">

    <div class="form-group">
        <label for="">Appréciation générale sur la progression de l’élève :</label>
        <textarea *ngIf="assessment" name="message" [(ngModel)]="assessment.message" class="form-control" required></textarea>
    </div>
  
  </form>
  </ng-container>
   
</div>


<ng-template #contentPDF let-offcanvas>
	<div class="offcanvas-header">
    
		<h4 class="offcanvas-title">Visualiseur de fichier</h4>
		<button id="closePDFBtn" type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
	</div>
	<div class="offcanvas-body">
        <ngx-extended-pdf-viewer [src]="pdfSrc"
        style="width: 100%; height: 100%"
        ></ngx-extended-pdf-viewer>
	</div>
</ng-template>

